module.exports = __webpack_public_path__ + "static/img/info_1.9192b8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/info_1.jpg
// module id = W5sT
// module chunks = 1